import { Input } from '@angular/core';
import { CustomerModel } from '../shared/models/customer-model';
import { Component, OnInit } from '@angular/core';
import { CustomerStatusEnum } from '@admin/customers/shared/models/customer-status.enum';
import { ConfigurationService } from '@admin/shared/services/configuration.service';

@Component({
  selector: 'hr-customer-agents',
  templateUrl: './customer-agents.component.html',
  styleUrls: ['./customer-agents.component.less'],
  standalone: false,
})
export class CustomerAgentsComponent implements OnInit {
  @Input()
  public customer: CustomerModel;

  public customerStatusEnum: any = CustomerStatusEnum;
  public dateFormat: string;

  constructor(private configService: ConfigurationService) {}

  ngOnInit() {
    const config = this.configService.getCachedConfig();
    this.dateFormat = config.dateFormat;
  }
}
